import { Form } from "react-router-dom";
import { motion as Motion } from "framer-motion";
import cls from "./AgeGate.module.scss";

/* Mobile images */
import MrM from "@/assets/UI/police/MrM.webp";
import MrsM from "@/assets/UI/police/MrsM.webp";
import PLM from "@/assets/UI/police/PLM.webp";
import PRM from "@/assets/UI/police/PRM.webp";

/* Desktop images */
import MrD from "@/assets/UI/police/MrD.webp";
import MrsD from "@/assets/UI/police/MrsD.webp";
import PLD from "@/assets/UI/police/PLD.webp";
import PRD from "@/assets/UI/police/PRD.webp";

/* ===== Animations (same feel as ClubSingle) ===== */
const floatSlow = {
  hidden: { opacity: 0.5 },
  show: {
    opacity: [0.5, 0.65, 0.5],
    scale: [1, 1.06, 1],
    transition: {
      duration: 10,
      ease: "easeInOut",
      repeat: Infinity,
    },
  },
};

const floatSlowAlt = {
  hidden: { opacity: 0.5 },
  show: {
    opacity: [1, 0.62, 1],
    scale: [1.06, 1, 1.06],
    x: [0, -6, 0],
    transition: {
      duration: 12,
      ease: "easeInOut",
      repeat: Infinity,
    },
  },
};

export default function AgeGate() {
  return (
    <main className={cls.page}>
      <div className={cls.pageInner}>
        <Form method="post">
          <section className={cls.heroStage} aria-label="Age Gate">
            {/* ===== MOBILE ===== */}
            <div className={cls.mobileOnly} aria-hidden="true">
              <Motion.img
                className={`${cls.heroImg} ${cls.z0}`}
                src={MrM}
                alt=""
                variants={floatSlow}
                initial="hidden"
                animate="show"
                draggable="false"
              />
              <Motion.img
                className={`${cls.heroImg} ${cls.z1}`}
                src={MrsM}
                alt=""
                variants={floatSlowAlt}
                initial="hidden"
                animate="show"
                draggable="false"
              />

              <button
                type="submit"
                name="choice"
                value="yes"
                className={`${cls.heroHalfBtn} ${cls.leftHalf}`}
                aria-label="Yes, let me in"
              >
                <img
                  src={PLM}
                  alt=""
                  className={`${cls.heroHalfImg} ${cls.z3}`}
                  draggable="false"
                />
              </button>

              <button
                type="submit"
                name="choice"
                value="no"
                className={`${cls.heroHalfBtn} ${cls.rightHalf}`}
                aria-label="No, run away"
              >
                <img
                  src={PRM}
                  alt=""
                  className={`${cls.heroHalfImg} ${cls.z3}`}
                  draggable="false"
                />
              </button>
            </div>

            {/* ===== DESKTOP ===== */}
            <div className={cls.desktopOnly} aria-hidden="true">
              <Motion.img
                className={`${cls.heroImg} ${cls.z0}`}
                src={MrD}
                alt=""
                variants={floatSlow}
                initial="hidden"
                animate="show"
                draggable="false"
              />
              <Motion.img
                className={`${cls.heroImg} ${cls.z1}`}
                src={MrsD}
                alt=""
                variants={floatSlowAlt}
                initial="hidden"
                animate="show"
                draggable="false"
              />

              <button
                type="submit"
                name="choice"
                value="yes"
                className={`${cls.heroHalfBtn} ${cls.leftHalf}`}
                aria-label="Yes, let me in"
              >
                <img
                  src={PLD}
                  alt=""
                  className={`${cls.heroHalfImg} ${cls.z3}`}
                  draggable="false"
                />
              </button>

              <button
                type="submit"
                name="choice"
                value="no"
                className={`${cls.heroHalfBtn} ${cls.rightHalf}`}
                aria-label="No, run away"
              >
                <img
                  src={PRD}
                  alt=""
                  className={`${cls.heroHalfImg} ${cls.z3}`}
                  draggable="false"
                />
              </button>
            </div>
          </section>
        </Form>
      </div>
    </main>
  );
}
